import { Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Component, EventEmitter, Output } from '@angular/core';
import { ListBase } from '../../../../../core/_infrastructure/classes/listBase';
import { NotificationService } from '../../../../../core/_infrastructure/classes/services/notification.service';
import { proxiedPropertiesOf } from '../../../../../core/_infrastructure/types/utils';
import { ListaPlazosPeriodoCamViewModel, PlazoPeriodoCamViewModel } from '../plazos.types';

@Component({
    selector: 'app-plazos-list',
    templateUrl: './plazos-list.component.html',
})
export class PlazosListComponent extends ListBase implements OnInit, OnChanges {
    @Input() listaPlazosPeriodo: ListaPlazosPeriodoCamViewModel;
    @Input() esPeriodoFinalizado = false;
    @Output() editEmitter = new EventEmitter<number>();
    @Output() deleteEmitter = new EventEmitter<number>();

    cols: any[];

    constructor(protected notificationService: NotificationService) {
        super(notificationService);
    }

    ngOnInit(): void {
        this.initCols();
        this.loading = false;
    }

    private initCols(): void {
        const plazoPeriodo = proxiedPropertiesOf<PlazoPeriodoCamViewModel>();

        this.cols = [
            { field: 'Link', header: '' },
            { field: plazoPeriodo.Id?.toString(), header: 'Id', display: 'none' },
            { field: plazoPeriodo.IdPeriodo?.toString(), header: 'IdPeriodo', display: 'none' },
            { field: 'Ordinal', header: 'Orden' },
            { field: plazoPeriodo.FechaInicioPresentacion?.toString(), header: 'Fecha Inicio Presentación' },
            { field: plazoPeriodo.FechaFinPresentacion?.toString(), header: 'Fecha Fin Presentación' },
            { field: plazoPeriodo.FechaInicioExportacionParcela?.toString(), header: 'Fecha Inicio Exportación Parcela' },
            { field: plazoPeriodo.FechaInicioExportacionConfeccion?.toString(), header: 'Fecha Inicio Exportación Confección' },
            { field: plazoPeriodo.FechaInicioExportacionInvernadero?.toString(), header: 'Fecha Inicio Exportación Invernadero' },
            { field: plazoPeriodo.FechaInicioExportacionEmpDeshidratadoras?.toString(), header: 'Fecha Inicio Exportación Emp. Deshidratación' },
        ];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.listaPlazosPeriodo?.currentValue) {
            this.listaPlazosPeriodo = { ...changes.listaPlazosPeriodo.currentValue };
            this.loading = false;
        }
    }

    onEdit(item: PlazoPeriodoCamViewModel): void {
        this.editEmitter.emit(item?.Id);
    }

    onDelete(item: PlazoPeriodoCamViewModel): void {
        this.deleteEmitter.emit(item?.Id);
    }

    esPlazoIniciado(item: PlazoPeriodoCamViewModel): boolean {
        if (!item) return true;
        if (!item.FechaInicioPresentacion) return false;
        const hoy = new Date();
        const fiP = new Date(item.FechaInicioPresentacion);
        if (hoy >= fiP) {
            return true;
        }
        return false;
    }
}
